<template>
  <div class="unit-items">
    <div class="unit-title">
      <h3
        class="font-weight-regular mb-0 black--text"
        :class="{ 'white--text': dark }"
      >
        {{ title }}
      </h3>
      <v-btn @click="add" class="ma-1 amber" fab small light v-if="!isLocked">
        <v-icon>mdi-plus</v-icon></v-btn
      >
    </div>

    <template v-if="!isLocked">
      <draggable
        class="inner mt-5"
        :list="items"
        group="order"
        @start="startDrag()"
        @end="endDrag()"
        :ref="name"
        :id="name"
      >
        <div
          v-for="(item, index) in items"
          :key="`unit-${name}-${index}`"
          class="item"
          :data-id="item.id"
        >
          <div class="item--flex">
            <p class="break-spaces">
              <span class="font-weight-bold">{{ item.title }}</span
              ><br /><span v-if="item.description">{{ item.description }}</span>
            </p>

            <div class="icons pa-1" v-if="addItem && !isLocked">
              <v-icon @click="edit(item)" class="white--text"
                >mdi-pencil</v-icon
              >
              <v-icon @click="remove(item)" class="white--text"
                >mdi-delete-forever</v-icon
              >
            </div>
          </div>
          <div v-if="item.options">
            <v-chip
              v-for="chip in item.options"
              :key="`${item.title}-${chip}`"
              class="white mr-1 mb-1"
              small
              >{{ chip }}</v-chip
            >
          </div>
        </div>
      </draggable>
    </template>

    <template v-else>
      <div
        v-for="(item, index) in items"
        :key="`unit-${name}-${index}`"
        class="item"
        :data-id="item.id"
      >
        <div class="item--flex">
          <p class="break-spaces">
            <span class="font-weight-bold">{{ item.title }}</span
            ><br />{{ item.description }}
          </p>

          <div class="icons pa-1" v-if="addItem && !isLocked">
            <v-icon @click="edit(item)" class="white--text">mdi-pencil</v-icon>
            <v-icon @click="remove(item)" class="white--text"
              >mdi-delete-forever</v-icon
            >
          </div>
        </div>
        <div v-if="item.options">
          <v-chip
            v-for="chip in item.options"
            :key="`${item.title}-${chip}`"
            class="white mr-1 mb-1"
            small
            >{{ chip }}</v-chip
          >
        </div>
      </div>
    </template>

    <v-dialog v-model="dialog" max-width="800">
      <v-card v-if="deleteMode" light>
        <v-card-title>
          Are you sure you want to delete this item?
        </v-card-title>
        <v-card-text class="">
          <v-btn light color="amber mr-5" class="" @click="removeItem"
            >Delete</v-btn
          >
          <v-btn light color="white" class="" @click="cancel">Cancel</v-btn>
        </v-card-text>
      </v-card>
      <v-card light v-else-if="editMode">
        <v-card-title>
          {{ title }}
        </v-card-title>
        <v-card-text class="">
          <v-textarea
            label="Title"
            color="green"
            v-model="item.title"
            :rows="1"
            :autoGrow="true"
            :hide-details="false"
          />
          <v-textarea
            label="Notes"
            color="green"
            v-model="item.description"
            :rows="3"
            :autoGrow="true"
            :hide-details="false"
          />
          <v-select
            v-if="options && options.length"
            :items="options"
            multiple
            label="Type"
            v-model="item.options"
            required
          ></v-select>

          <v-btn light color="green" class="mt-2 mr-2" @click="editItem"
            >Update</v-btn
          >
          <v-btn light color="white" class="mt-2 mr-2" @click="cancel"
            >Cancel</v-btn
          >
        </v-card-text>
      </v-card>
      <v-card light v-else>
        <v-card-title>
          {{ title }}
        </v-card-title>
        <v-card-text class="">
          <v-textarea
            label="Title"
            color="green"
            v-model="item.title"
            :rows="1"
            :autoGrow="true"
            :hide-details="false"
          />
          <v-textarea
            label="Description"
            color="green"
            v-model="item.description"
            :rows="3"
            :autoGrow="true"
            :hide-details="false"
          />
          <v-select
            v-if="options && options.length"
            :items="options"
            multiple
            label="Type"
            v-model="item.options"
            required
          ></v-select>
          <v-btn light color="green" class="mt-2 mr-2" @click="addItem"
            >Add</v-btn
          >
          <v-btn light color="white" class="mt-2 mr-2" @click="cancel"
            >Cancel</v-btn
          >
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
// @ is an alias to /src
import draggable from "vuedraggable";

export default {
  name: "QuadrantItems",
  data() {
    return {
      items: this.value,
      item: {},
      refs: null,
      fields: [],
      editMode: false,
      editIndex: null,
      deleteMode: false,
      deleteId: null,
      dialog: false,
      currItem: null,
      currIndex: null,
    };
  },
  props: {
    value: Array,
    name: String,
    title: String,
    isLocked: {
      type: Boolean,
      default: false,
    },
    isAdmin: {
      type: Boolean,
      default: false,
    },
    dark: {
      type: Boolean,
      default: false,
    },
    options: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    draggable,
  },
  watch: {
    value: {
      handler: function(val) {
        this.items = val;
      },
      deep: true,
    },
  },
  mounted() {
    if (this.collection) {
      this.getRefs();
    }
  },
  methods: {
    rand() {
      return Math.random()
        .toString(36)
        .substr(2);
    },
    generateToken() {
      console.log("token");
      return this.rand() + this.rand() + this.rand();
    },
    checkToken(id) {
      console.log("check token");
      return id.toString().length < 3 ? this.generateToken() : id;
    },
    add() {
      this.dialog = true;
    },
    addItem() {
      let item = {
        index: this.items.length,
        id: this.generateToken(),
        type: "content",
        ...this.item,
      };
      this.items.push(item);
      this.item = {};
      this.editMode = false;
      this.dialog = false;
      this.$emit("change");
    },
    remove(target) {
      this.deleteMode = true;
      const item = this.items.find((x) => x.id === target.id);
      const index = this.items.indexOf(item);
      this.item = item;
      this.currIndex = index;
      this.dialog = true;
      this.$emit("change");
    },
    removeItem() {
      this.items.splice(this.currIndex, 1);
      this.cancel();
    },
    edit(target) {
      const item = this.items.find((x) => x.id === target.id);
      const index = this.items.indexOf(item);
      this.item = item;
      this.currIndex = index;
      this.editMode = true;
      this.dialog = true;
    },

    editItem() {
      let item = {
        ...this.item,
        index: this.currIndex,
        id: this.checkToken(this.item.id),
        type: "content",
      };
      this.$set(this.items, this.currIndex, item);
      this.item = {};
      this.currItem = null;
      this.currIndex = null;
      this.editMode = false;
      this.dialog = false;
      this.$emit("change");
    },
    cancel() {
      this.dialog = false;
      this.deleteId = null;
      this.deleteMode = false;
      this.editMode = false;
    },
    startDrag() {
      this.dragging = true;
    },
    endDrag() {
      let count = 0;
      let vm = this;
      let div = document.getElementById(this.name);
      div.children.forEach((doc) => {
        let item = this.items.find((x) => x.id == doc.dataset.id);
        if (item) {
          let indexOfItem = this.items.indexOf(item);
          item.index = count;
          vm.$set(vm.items, indexOfItem, item);
        }
        count++;
      });
      this.dragging = false;
      this.$emit("change");
    },
  },
};
</script>

<style lang="scss" scoped>
.unit-items {
  .item {
    &--flex {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
    }
    padding: 0.5rem;
    margin: 0.5rem 0;
    background: #2b2a2a;
    border-radius: 5px;
    color: white;
    .icons {
      width: 50px;
      padding: 0 10px 0 10px;
      display: flex;
    }
  }
}
.unit-title {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}
.add-button {
  margin: 0 !important;
  position: relative;
  right: 0;
}
.unit-field {
  margin: 0.75rem 0 !important;
}
</style>
